import { apiClient } from "@/services/api.client"
import { saveAs } from "file-saver"

/**
 * Download a private case document (an uploaded SCN/reply file) through the
 * authenticated backend proxy (nitiassist → oio_service, which reads GCS with
 * the service account), then save it under its original filename.
 *
 * Uploaded case documents are PRIVATE in GCS, so the browser CANNOT fetch the
 * blob_url directly — a plain `fetch(blobUrl)` or `<a href={blobUrl}>` 403s.
 */
export async function fetchCaseDocument(blobUrl: string): Promise<Blob> {
  return apiClient.postForBlob("/api/v1/storage/download", { blob_url: blobUrl })
}

export async function downloadCaseDocument(blobUrl: string, filename: string): Promise<void> {
  const blob = await fetchCaseDocument(blobUrl)
  saveAs(blob, filename)
}
